import qs from 'query-string';
import { useCallback, useEffect, useMemo } from 'react';
import { useHistory } from 'react-router-dom';

export enum MenuStateEnum {
  Viewer = 'viewer',
  DrawingFileManagement = 'drawingfile_management',
  Request = 'request',
  Quotation = 'quotation',
  PurchaseOrder = 'purchaseorder',
  CreatePurchaseOrder = 'create_purchaseorder',
  Kebab = 'kebab',
  Helper = 'helper'
}

export type DeprecatedMenuState =
  | 'Viewer'
  | 'DrawingFileManagement'
  | 'Request'
  | 'Quotation'
  | 'PurchaseOrder'
  | 'CreatePurchaseOrder'
  | 'ReCreatePurchaseOrder'
  | 'Helper';

export const menu = {
  viewer: 'viewer',
  drawingfile_management: 'drawingfile_management',
  request: 'request',
  quotation: 'quotation',
  purchaseorder: 'purchaseorder',
  create_purchaseorder: 'create_purchaseorder',
  kebab: 'kebab',
  helper: 'helper'
};

export type MenuTypes = keyof typeof menu | 'init';

const useDrawer = (): [
  { menu: MenuTypes },
  (value?: MenuTypes, isTraking?: boolean) => void
] => {
  const history = useHistory();

  const parsed = qs.parse(history.location.search) as {
    sidemenu?: DeprecatedMenuState;
    menu: MenuTypes;
    mode?: string;
  };

  const update = useCallback(
    (value?: MenuTypes | 'init', isTraking?: boolean) => {
      if (!value) return history.replace('/chat');

      if (parsed?.mode === 'reissue') {
        return history.push(`${history.location.pathname}?menu=${parsed.menu}`);
      }

      if (value === 'init') {
        const prevInChat = history.location.search.includes('kebab');

        return history.replace(`${history.location.pathname}`, { prevInChat });
      }

      if (parsed.menu === value) {
        return history.replace(`${history.location.pathname}`);
      }
      if (value === 'quotation') {
        return history.push(
          `${history.location.pathname}?menu=${value}${isTraking ? '&p=1' : ''}`
        );
      }
      if (value === 'create_purchaseorder') {
        return history.push(`${history.location.pathname}?menu=${value}&p=2`);
      }
      return history.push(`${history.location.pathname}?menu=${value}`);
    },
    [history, parsed]
  );

  const deprecatedMenu = useMemo(() => {
    if (parsed?.sidemenu === 'PurchaseOrder') {
      return 'purchaseorder';
    }

    if (parsed?.sidemenu === 'Quotation') {
      return 'quotation';
    }

    if (parsed?.sidemenu === 'Request') {
      return 'request';
    }

    if (parsed?.sidemenu === 'DrawingFileManagement') {
      return 'drawingfile_management';
    }

    return undefined;
  }, [parsed]);

  useEffect(() => {
    if (!deprecatedMenu) return;

    if (deprecatedMenu) {
      history.replace(`${history.location.pathname}?menu=${deprecatedMenu}`);
    }
  }, [history, deprecatedMenu]);

  return [parsed, update];
};

export default useDrawer;
